<template>
  <modal :name="modalName" class="vue-dialog">
    <div class="dialog-content">
      <div>
        <div class="dialog-c-title">Login to Edit Menus</div>
        <div class="dialog-c-text">
          <div class="field-wrap">
            <input type="text" v-model="username" name="username" placeholder="username">
          </div>
          <div class="field-wrap">
            <input type="password" v-model="password" name="password" placeholder="password">
          </div>
          <div class="error" v-if="error" v-html="error"></div>
          <div class="success" v-if="success">Successfully logged in!</div>
          <div v-if="loading">Logging in...</div>
        </div>
      </div>
      <div class="vue-dialog-buttons flex-container">
        <button :disabled="!validCredentials" class="vue-dialog-button flex-item flex-2-md flex-2-sm" @click="authPromise">Login</button>
        <button class="vue-dialog-button flex-item flex-2-md flex-2-sm" @click="$modal.hide(modalName)">{{ success? 'OK' : 'Cancel'}}</button>
      </div>
    </div>

  </modal>
</template>
<script>
export default {
  name: 'LoginModal',
  data() {
    return {
      username: 'test',
      // password: 'xLbWxYFGF@%i2Z2r(O',
      password: 'test',
      loading : false,
      success : false,
      error : false,
      modalName : 'login-modal'
    }
  }, // data

  computed : {
    validCredentials() {
      return this.username.length > 0 && this.password.length > 0;
    }
  },

  methods: {
    authPromise() {
      this.loading = true;
      this.$store.dispatch('authPromise', {username:this.username,password:this.password } )
        .then( (r) => {
          this.loading = false;
          // console.log(r)
          // successfully returning the authToken
          if( typeof r == 'string' ) {
            this.error = false;
            this.success = true;
            setTimeout(() => {
              this.$modal.hide(this.modalName);
              this.$store.commit('toggleUI');
            }, 1200)
          } else {
            // Some kind of error obj
            this.error = r.response.data.message;
          }
        })
    }, // authPromise
  }
}
</script>
<style lang="scss">
.flex-container {
  display:flex;
  flex-wrap:wrap;
  .flex-item {
    flex:1;
    flex-basis:100%;
    &.flex-2-md, &.flex-2-md {
      flex:1 1 50%;
    }
  }  
}

body .vue-dialog, body[data-form-style="minimal"] .vue-dialog {
  font-size:1rem;
  color:#666;
  .dialog-content {
    height:100%;
    position:relative;
  }
  .dialog-c-title {
    font-size:1.7rem;
    text-align:center;
  }
  .field-wrap {
    padding:10px 0px;
    input {
      width:100%;
      border:1px solid #DDD;
      padding:.3em .5em !important;
      &:focus {
        outline:none;
      }
    }
  }
  .vue-dialog-buttons {
    position:absolute;
    bottom:0;
    right:0;
    left:0;
    font-size:0.9rem;
    button {
      transition:background-color, .3s ease, color .3s ease;
      text-transform: uppercase;
      justify-content:center;
      &[disabled="disabled"] {
        color:#bfbfbf;
      }
    }
  }
  .error {
    padding: 10px 0;
    line-height: 1.3;    
  }
}  
</style>


// WEBPACK FOOTER //
// src/components/UI/LoginModal.vue